<template>
  <b-card title="List Categery Spareparts">
    <b-col cols="12">
      <b-row class="mb-2">
        <b-col cols="3">
          <b-button
            variant="success"
            :to="{ name: 'add-sparepart-category' }"
            v-if="permission.add"
            >
            Add Category
          </b-button>
        </b-col>
        <b-col cols="3"/>
        <b-col cols="3">
          <b-form-input
            v-model="search"
            type="search"
            placeholder="Type to Search"
          />
        </b-col>
        <b-col cols="3">
          <b-button @click="userFilter" class="" variant="primary">Search</b-button>    
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
            :items="data"
            :fields="fields"
            :busy.sync="tableLoading"
          >
            <template #cell(actions)="row">
              <b-dropdown
                id="dropdown-dropleft"
                variant="primary"
                size="sm"
                text="Menu"
                no-caret
              >
                <template #button-content>
                  <feather-icon size="1x" icon="MenuIcon" />
                </template>
                  <b-dropdown-item
                    style="text-align:center"
                    v-if="permission.edit"
                  >
                    <b-button
                      class="mr-1"
                      variant="outline-primary"
                      :to="{ name: 'edit-sparepart-category', params: { id: row.item.id } }"
                      >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-dropdown-item>
                  <b-dropdown-item
                    style="text-align:center"
                    v-if="permission.delete"
                  >
                    <b-button
                      @click="promptDeleteUser(row)"
                      class="mr-1"
                      variant="danger"
                    >
                      <feather-icon icon="Trash2Icon" />
                    </b-button>
                  </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            @change="onPageChange"
            v-model="currentPage"
            style="float: right"
          />
        </b-col>
      </b-row>
    </b-col>

    <b-modal ref="modal" v-model="promptDelete" title="Confirm Delete Category">
      <p class="my-2">
        Delete category ?
      </p>
      <template #modal-footer>
        <b-button size="md" variant="danger" @click="doDelete">
          Yes
        </b-button>
        <b-button size="md" variant="success" @click="promptDelete = false">
          Cancel
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import { mapActions, mapState,mapGetters } from "vuex";
import { userAccess } from "@/utils/utils";

export default {
  data() {
    return {
      selected: [],
      fields: [
        { key: "name", text: "Name", filterable: true, sortable: true },
        { key: "description", text: "Description", filterable: true, sortable: true },
        { key: "actions", text: "Actions" },
      ],
      search: "",
      promptDelete: false,
      deleteUserId: "",
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      totalData:0,
      tableLoading:false
    };
  },
  mounted() {
    this.get({
      page:this.currentPage,
      entry:this.perPage
    })
    .then((metadata) => this.processMetadata(metadata));;
  },
  computed: {
    ...mapGetters({
      data: 'category/spareparts',
    }),
    permission() {
      return userAccess("Sparepart Category", "masterdata_menu");
    }
  },
  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    ...mapActions({
      get: "category/getCategoriesSparepart",
      delete: "category/deleteCategoriesSparepart",
    }),
    userFilter(){
      this.currentPage=1;
      this.get({
        page:this.currentPage,
        entry:this.perPage,
        filter:this.search
      }).then((metadata)=>{
        this.processMetadata(metadata)
      });
    },
    onPageChange(page) {
      this.currentPage=page
      this.getData()
    },
    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
      this.tableLoading = false;
    },
    promptDeleteUser(row) {
      this.deleteUserId = row.item.id;
      this.promptDelete = true;
    },
    getData(){
      this.get({ 
        page:this.currentPage,
        entry:this.perPage,
        filter:this.search,
      }).then((metadata) => this.processMetadata(metadata));
    },
    doDelete() {
      this.delete(this.deleteUserId)
        .then(() => {
          this.promptDelete = false;
          this.$bvToast.toast("Successfully Delete Category", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.currentPage=1;
          this.getData()
        })
        .catch((e) => {
          console.error(e);
          this.$bvToast.toast(`Delete Category Failed`, {
            title: "Fail",
            variant: "danger",
            solid: true,
          });
        });
    },
  },
  created() {
    document.title = "Category Spareparts  | RSP";
  },
};
</script>

<style scoped>
.dropdown-show{
  overflow-y: auto;
  height: 80px;
}
</style>